import React, { useEffect, useState } from "react"
import MUIDataTable from "mui-datatables"

import { MuiThemeProvider } from "@material-ui/core/styles"

import {
  GetMuiThemeEco,
  GetMuiThemeOem,
} from "Components/UI/Atoms/Table/DynamicStyle"
import { useLocation } from "react-router-dom"
import { getUbicacion } from "service/helpers/localstorage"
import { Options } from "Components/UI/Atoms/Table/Options"

const MuiDatables = (props) => {
  const {
    title,
    data,
    columns,
    apiCall,
    count,
    textPlaceholder,
    render,
    setRender,
    columnTheme,
    searchEnabled,
    expandableRows,
    renderExpandableRow,
    selectableRows,
    customToolbarSelect,
    customToolbar,
    padding,
    filterEnabled,
    isRowSelectable,
    setRowProps,
    rows = 25,
    advancedSearch,
    onRowClick,
    searchFirst,
  } = props

  const [offset, setOffset] = useState(0)
  const [isSearching, setIsSearching] = useState(true)
  const [sort, setSort] = useState({
    orderBy: "id",
    order: "desc",
  })
  const [filters, setFilters] = useState()
  const [search, setSearch] = useState()

  const { pathname } = useLocation()
  const location = getUbicacion() || ""

  const theme = () => {
    if ((pathname && pathname.includes("oem")) || location.includes("OEM"))
      return GetMuiThemeOem(columnTheme)
    return GetMuiThemeEco(columnTheme)
  }

  const functions = {
    render,
    filters,
    setRender,
    setSort,
    setSearch,
    setOffset,
    setFilters,
    isSearching,
    count,
    textPlaceholder,
    searchEnabled,
    expandableRows,
    renderExpandableRow,
    selectableRows,
    customToolbarSelect,
    customToolbar,
    padding,
    filterEnabled,
    isRowSelectable,
    setRowProps,
    rows,
    onRowClick,
    searchFirst,
  }

  useEffect(() => {
    setIsSearching(true)
    let options = {
      offset: `?offset=${offset}`,
      limit: `&limit=${rows}`,
      orderby: `&orderby=${sort.orderBy}`,
      order: `&order=${sort.order}`,
      search: "",
      filters: filters,
    }
    if (search !== undefined) {
      options.search = `&search=${search}`
    }
    if (advancedSearch && advancedSearch !== "") {
      options.search = advancedSearch
    }
    let finalQuery = Object.values(options).join("")
    apiCall(finalQuery, function () {
      setIsSearching(false)
    })
    // eslint-disable-next-line
  }, [render])

  return (
    <React.Fragment>
      <MuiThemeProvider theme={theme()}>
        <MUIDataTable
          title={title}
          data={data}
          columns={columns}
          options={Options(functions)}
        />
      </MuiThemeProvider>
    </React.Fragment>
  )
}
export default MuiDatables
